import { render, staticRenderFns } from "./TaskActions.vue?vue&type=template&id=b9ed13da&scoped=true&"
import script from "./TaskActions.vue?vue&type=script&lang=js&"
export * from "./TaskActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ed13da",
  null
  
)

export default component.exports